/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

import {
  avatar1,
  avatar2,
  avatar3,
  atomicHabits,
  beginnerStockMarket,
  blockchain,
  buildSideProjects,
  dietMentalPhysical,
  efficentDevImage,
  ExerciseParadox,
  fifteenBooks22,
  finanacialBasics,
  financebeginner,
  futureElon,
  getRichNaval,
  mentalHealthAnna,
  mustReadBooksMS,
  personalFinance21,
  powerOfFitness,
  steveJobs,
  whatMentalHealth,
  youngestBillionare,
} from "../../assets";
export const videos = [
  {
    _id: "37UhELFvPec",
    title: "Power of Fitness",
    categoryName: "Health",
    videoUrl: "https://youtu.be/37UhELFvPec",
    description:
      "Why exercise is an important part of a healthy lifestyle. Vincent Lam has had a passion for fitness for as long as he can remember. His goal is to help people restore, maintain, and promote quality of life and optimal physical function. He is devoted to helping others achieve their fitness goals. He graduated from Penn State with a B.S. in kinesiology and is also a certified personal trainer. This talk was given at a TEDx event using the TED conference format but independently organized by a local community. ",
    creator: "TEDx",
    avatar: avatar2,
    thumbUrl: powerOfFitness,
    duration: "15:44",
    views: "33.4k",
  },

  {
    _id: "J0cD6Mqe944",
    title: "Financial basics for Indians",
    categoryName: "Finance",
    videoUrl: " https://youtu.be/J0cD6Mqe944",
    description:
      "hin Kamath is back again. Part 1 was all about the story of Zerodha. The real bootstrapped success story. ",
    creator: "BeerBiceps",
    avatar: avatar1,
    thumbUrl: finanacialBasics,
    duration: "37:06",
    views: "2M",
  },
  {
    _id: "lCrMAtbBUJA",
    title: "15 Books to read in 2022",
    videoUrl: "https://www.youtube.com/watch?v=lCrMAtbBUJA",
    categoryName: "Books",
    creator: "Ali Abdaal ",
    description: "In this video Ali Abdaal suggests her book recommendation",
    avatar: avatar3,
    thumbUrl: fifteenBooks22,
    duration: "23:18",
    views: "50k",
  },
  {
    _id: "8so1WZ4j1oQ",
    title: "The exercise paradox",
    videoUrl: "https://youtu.be/8so1WZ4j1oQ",
    categoryName: "Health",
    creator: "TEDx",
    description:
      "How can you manipulate your brain to achieve greater levels of happiness? Can you be so inspired that your daily exercises bring you joy and increase your self-esteem? By practicing the four key strategies given in this TEDx talk, we can all achieve greater levels of energy, mood and overall health along with positive long-term changes in our physiques.",
    avatar: avatar2,
    thumbUrl: ExerciseParadox,
    duration: "15",
    views: "4.4k",
  },
  {
    _id: "TZqOsVCNM",
    title: "Get rich without getting lucky",
    categoryName: "Finance",
    videoUrl: " https://www.youtube.com/watch?v=1-TZqOsVCNM",
    description: "Naval story ",
    creator: "Naval",
    avatar: avatar2,
    thumbUrl: getRichNaval,
    duration: "18:64",
    views: "67k",
  },
  {
    _id: "oxx564hMBUI",
    title: "What is mental health?",
    videoUrl: "https://www.youtube.com/watch?v=oxx564hMBUI",
    categoryName: "Health",
    creator: "The School of Life",
    description:
      "Nowadays, we know more and more about what it means to be mentally unwell - but what exactly constitutes mental 'health’? In this film, we’ll explore what characterises an optimally functioning mind. ",
    avatar: avatar2,
    thumbUrl: whatMentalHealth,
    duration: "11",
    views: "12k",
  },
  {
    _id: "cpg78ouK54I",
    title: "Billionare on How to make money",
    videoUrl: "https://www.youtube.com/watch?v=cpg78ouK54I",
    categoryName: "Finance",
    creator: "Raj Shamani",
    description:
      "Nikhil Kamath, 35, co-founded Zerodha, India's largest trading platform by volume, with his older brother Nithin in 2010 in the southern Indian city of Bangalore. In this video, he discusses how he moved out of his house and went from working at a Call Centre to Building up One of the Largest Businesses and becoming India's Youngest Billionaire! ",
    avatar: avatar1,
    thumbUrl: youngestBillionare,
    duration: "37",
    views: "1.5M",
  },
  {
    _id: "EjsTWJ7U1rk",
    title: "Atomic habbits Summary",
    videoUrl: "https://www.youtube.com/watch?v=EjsTWJ7U1rk",
    categoryName: "Books",
    creator: "Readers book club ",
    description: "This video contain summary of Atomic Habits",
    avatar: avatar3,
    thumbUrl: atomicHabits,
    duration: "11:02",
    views: "3k",
  },
  {
    _id: "DxIDKZHW3-E",
    title: "We all have mental health",
    videoUrl: "https://youtu.be/DxIDKZHW3-E",
    categoryName: "Health",
    creator: "Anna Freud NCCF",
    description:
      "We All Have Mental Health is an animation designed to give young people aged 11-14 a common language and understanding of what we mean by mental health and how we can look after it. It has been created for young people in Key stage 3 and can be used with accompanying teaching resources.. ",
    avatar: avatar2,
    thumbUrl: mentalHealthAnna,
    duration: "20:09",
    views: "34.39k",
  },
  {
    _id: "PU4zArf71Yg",
    title: "Building a side Projects",
    videoUrl: "https://youtu.be/PU4zArf71Yg",
    categoryName: "Technology",
    creator: "Tanay Pratap",
    description:
      "In episode 2, Rachit Gulati from Microsoft joins Tanay to talk about how he got started with hobby projects and how they helped him in cracking interviews. Rachit goes on to explain how once can go about doing hobby projects and benefit from them. ",
    avatar: avatar2,
    thumbUrl: buildSideProjects,
    duration: "32:15",
    views: "80k",
  },
  {
    _id: "3UF0ymVdYLA",
    title: "Stock market for beginners",
    videoUrl: "https://www.youtube.com/watch?v=3UF0ymVdYLA",
    categoryName: "Finance",
    creator: "Pranjal Kamra",
    description:
      "Stock Market for Beginners is the introductory video for everyone who is interested in investing in the share market. ",
    avatar: avatar1,
    thumbUrl: beginnerStockMarket,
    duration: "17:82",
    views: "46K",
  },
  {
    _id: "qeMmxq0MT6g",
    title: "Easy explaination of Blockchain",
    videoUrl: "https://youtu.be/qeMmxq0MT6g",
    categoryName: "Technology",
    creator: "BeerBiceps ",
    description: "How blockchain works by Indian Crypto millionaire",
    avatar: avatar1,
    thumbUrl: blockchain,
    duration: "13:69",
    views: "6k",
  },

  {
    _id: "nbrkmJTuGoY",
    title: "Personal Financial Stratergies 2021",
    videoUrl: "https://www.youtube.com/watch?v=nbrkmJTuGoY",
    categoryName: "Finance",
    creator: "Ankoor warikoo ",
    description:
      "Budgeting your #money is the key to having enough,” said Elizabeth Warren.Since we have entered a new financial year, in this video I will share my #PersonalFinance resolutions that I have planned for the next twelve months. And yes, I’ve been doing it since my college days when I used to spend Rs. 7,500 per month. So these budgeting, allocations and places where I will spend my money without thinking – apply even to college kid ",
    avatar: avatar1,
    thumbUrl: personalFinance21,
    duration: "17:56",
    views: "56K",
  },
  {
    _id: "KXgBQS9Lbl8&t=105s",
    title: "Book You must read if you hate reading",
    videoUrl: "https://www.youtube.com/watch?v=KXgBQS9Lbl8&t=105s",
    categoryName: "Books",
    creator: "Mostlysane ",
    description: "In this video mostlysane suggests her book recommendation",
    avatar: avatar3,
    thumbUrl: mustReadBooksMS,
    duration: "12:44",
    views: "3M",
  },
  {
    _id: "cyC6O81Bk",
    title: "Habits of efficient developers",
    videoUrl: "https://youtu.be/9-cyC6O81Bk",
    categoryName: "Technology",
    creator: "TED ",
    description:
      "Even if a 10x developer may be a myth, we all know of some developer that just shines and is able to do more in less time, and seems to do it without effort! Even if may seem that you need some kind of special natural talent, it is not.In this session by Daniel Lebrero you can learn what you need to learn to become a more efficient developer.",
    avatar: avatar1,
    thumbUrl: efficentDevImage,
    duration: "13:24",
    views: "65k",
  },
  {
    _id: "vGad9MvQEwo",
    title: "Best diet for mental and brain health",
    videoUrl: "https://youtu.be/vGad9MvQEwo",
    categoryName: "Health",
    creator: "Dr Caroline Leaf",
    description:
      "In this podcast I talk to Harvard-trained nutritional psychiatrist Dr. Georgia Ede about how certain diets can affect our mental wellbeing, what foods help the brain function best, and what foods to avoid if we want to heal and improve our mental and physical health. ",
    avatar: avatar2,
    thumbUrl: dietMentalPhysical,
    duration: "15:44",
    views: "8k",
  },

  {
    _id: "LLdKcFpHgM8",
    title: "Financial planning for beginners",
    videoUrl: "https://youtu.be/LLdKcFpHgM8",
    categoryName: "Finance",
    creator: "CA Rachana Ranade ",
    description: "A CA explains basic finance for beginners ",
    avatar: avatar1,
    thumbUrl: financebeginner,
    duration: "18:44",
    views: "14k",
  },
  {
    _id: "zIwLWfaAg-8",
    title: "The future we are building-Elon Musk",
    videoUrl: "https://youtu.be/zIwLWfaAg-8",
    categoryName: "Technology",
    creator: "TED ",
    description:
      "Elon Musk discusses his new project digging tunnels under LA, the latest from Tesla and SpaceX and his motivation for building a future on Mars in conversation with TED's Head Curator, Chris Anderson ",
    avatar: avatar1,
    thumbUrl: futureElon,
    duration: "35:23",
    views: "8M",
  },
  {
    _id: "zAS1nXFqBM8",
    title: "Steve Jobs favourite books",
    videoUrl: "https://www.youtube.com/watch?v=zAS1nXFqBM8",
    categoryName: "Book",
    creator: "Alux.com ",
    description: "Steve jobs book recommendation",
    avatar: avatar3,
    thumbUrl: steveJobs,
    duration: "12:43",
    views: "78k",
  },
];
